import { schema } from 'normalizr'

const phoneViewsSchema = new schema.Entity(
    'phoneViews',
    {},
    {
        idAttribute: 'phone_view_id',
    },
)

export default [phoneViewsSchema]
